import React from 'react'

interface ActivityCardProps {
  icon: React.ComponentType<any>
  title: string
  description: string
  type: string
  onDragStart?: (e: React.DragEvent) => void
  onAddToWorkflow?: (activity: any) => void
}

const ActivityCard: React.FC<ActivityCardProps> = ({
  icon: Icon,
  title,
  description,
  type,
  onDragStart,
  onAddToWorkflow,
}) => {
  const handleDragStart = (e: React.DragEvent) => {
    e.dataTransfer.setData('text/plain', JSON.stringify({ type, title, description }))
    if (onDragStart) onDragStart(e)
  }

  return (
    <div
      className="bg-white border border-slate-200 rounded-lg p-3 cursor-grab hover:shadow-sm transition-all duration-200 dark:bg-zink-600 dark:border-zink-500 hover:border-custom-300 dark:hover:border-custom-400"
      draggable
      onDragStart={handleDragStart}
      onClick={() => onAddToWorkflow && onAddToWorkflow({ type, title, description })}
    >
      <div className="flex items-center gap-3">
        <div className="p-1.5 bg-custom-100 rounded-md dark:bg-custom-500/20 flex-shrink-0">
          <Icon className="h-4 w-4 text-custom-500" />
        </div>
        <div className="flex-1 min-w-0">
          <h4 className="text-xs font-medium text-slate-800 dark:text-zink-50 truncate">{title}</h4>
        </div>
      </div>
    </div>
  )
}

export default ActivityCard
